/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import type Router from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';
import type AiAgentSetupService from 'embercom/services/ai-agent-setup-service';
import { FinGettingStartedState } from 'embercom/lib/reporting/fin-getting-started-states';

export default class FinAiAgentSalesIndexRoute extends Route {
  @service declare router: Router;
  @service declare appService: AppService;
  @service declare aiAgentSetupService: AiAgentSetupService;
  @service declare permissionsService: $TSFixMe;

  gettingStarted = new FinGettingStartedState(this, 'sales');

  async beforeModel() {
    let currentURLBeforeLoadingData = this.router.currentURL;
    let gettingStartedState = null;
    try {
      gettingStartedState = await this.gettingStarted.getState();
    } catch (e: unknown) {
      // On failure, fall through to the isSalesLive / get-started branches below.
      console.error(e);
    }
    await this.aiAgentSetupService.load();
    if (currentURLBeforeLoadingData !== this.router.currentURL) {
      return;
    }

    let canSeeReports = this.permissionsService.currentAdminCan('can_access_reporting');
    let isSalesLive =
      this.aiAgentSetupService.isSalesChatLive || this.aiAgentSetupService.isSalesEmailLive;

    if (gettingStartedState) {
      this.router.replaceWith('apps.app.automation.fin-ai-agent.sales.get-started');
    } else if (isSalesLive && canSeeReports) {
      this.router.replaceWith('apps.app.automation.fin-ai-agent.sales.performance');
    } else {
      this.router.replaceWith('apps.app.automation.fin-ai-agent.sales.get-started');
    }
  }
}
